import type { IconProps } from './icons';
import { createSvgIcon } from './icons';

export default function CloseIcon(props: IconProps) {
    const svg = <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 -960 960 960" width="100%" fill="#currentColor">
                    <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/>
                </svg>;
    return (
        createSvgIcon(svg, props)
    );
}